import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { I18nService } from '../../core/i18n.service';
import { MultiLanguageService } from '../../parts/multi-language/multi-language.service';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'translateObject',
    pure: false,
    standalone: true,
})
export class TranslateObjectPipe implements PipeTransform {
    private i18nService = inject(I18nService);
    private multiLangSvc = inject(MultiLanguageService);


    transform(query: Object, language?: string): any {
        if (!query) {
            return '';
        }
        const isEmpty = Object.keys(query).length === 0;
        if (isEmpty) {
            return '';
        }
        try {
            const lang = language ?? this.get3CharLanguage;
            const value = query[lang];
            return value ?? Object.values(query)[0];
        } catch (e) {
            return '';
        }
    }

    // TODO: Delete when 3 charachters will be available
    get get3CharLanguage() {
        return this.multiLangSvc.get3CharLanguage();
    }
}
